"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranteeOwnerRemoveIcon = exports.GranteeRemoveIcon = exports.GranteeGroupIcon = exports.GranteeUserInactiveIcon = exports.GranteeUserIcon = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Bubble_1 = require("../../../Bubble");
var Bubble_2 = require("../../../Bubble");
var ComponentLabelsContext_1 = require("./ComponentLabelsContext");
var alignPoints = [{ align: "cr cl" }];
exports.GranteeUserIcon = function () {
    return (react_1.default.createElement("div", { className: "gd-grantee-item-icon-left-background" },
        react_1.default.createElement("span", { className: "gd-grantee-item-icon gd-grantee-icon-user gd-grantee-item-icon-left" })));
};
exports.GranteeUserInactiveIcon = function () {
    return (react_1.default.createElement("div", { className: "gd-grantee-item-icon-left-background" },
        react_1.default.createElement("span", { className: "gd-grantee-item-icon-inactive gd-grantee-icon-user gd-grantee-item-icon-left" })));
};
exports.GranteeGroupIcon = function () {
    return (react_1.default.createElement("div", { className: "gd-grantee-item-icon-left-background" },
        react_1.default.createElement("span", { className: "gd-grantee-item-icon gd-grantee-icon-group gd-grantee-item-icon-left" })));
};
exports.GranteeRemoveIcon = function (props) {
    var onClick = props.onClick, mode = props.mode;
    var labels = ComponentLabelsContext_1.useComponentLabelsContext();
    return (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0, className: "gd-grantee-item-delete" },
        react_1.default.createElement("span", { className: "gd-grantee-item-icon gd-grantee-icon-trash gd-grantee-item-icon-right s-gd-grantee-item-delete", onClick: onClick }),
        react_1.default.createElement(Bubble_2.Bubble, { className: "bubble-primary", alignPoints: alignPoints }, mode === "ShareGrantee" ? (react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            labels.removeAccessGranteeTooltip,
            " ")) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.item.remove.selection" })))));
};
exports.GranteeOwnerRemoveIcon = function () {
    var labels = ComponentLabelsContext_1.useComponentLabelsContext();
    return (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0, className: "gd-grantee-item-delete-owner" },
        react_1.default.createElement("span", { className: "gd-grantee-item-icon gd-grantee-item-icon-owner gd-grantee-item-icon-right" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.item.creator" })),
        react_1.default.createElement(Bubble_2.Bubble, { className: "bubble-primary", alignPoints: alignPoints }, labels.removeAccessCreatorTooltip)));
};
//# sourceMappingURL=GranteeIcons.js.map